<template>
  <v-card
    v-intersect="onIntersect"
    flat
    class="rounded-0 pb-1 pt-4 mb-0"
    :style="cardStyle"
  >
    <v-row
      v-for="(item, i) in value.extraFields"
      :key="i"
      no-gutters
      class="pt-2 px-5"
      :style="textStyle"
    >
      <v-col
        cols="12"
        class="d-flex align-start"
        :style="textStyle"
        :tag="extraIsLink(item) ? 'a' : 'div'"
        :target="extraIsLink(item) ? '_blank' : null"
        :href="extraIsLink(item) ? fixLink(item.link) : null"
        :class="{ 'link-tag': extraIsLink(item) }"
      >
        <span v-if="item.icon" class="text-no-wrap me-1">
          <v-icon :color="value.pallete.textColor">
            {{ item.icon }}
          </v-icon>
          :
        </span>

        <pre
          v-if="item.value"
          class="text-right mb-0 mt-1"
          :style="textStyle"
          :class="{ 'link-tag': extraIsLink(item) }"
          v-html="item.value"
        />
      </v-col>

      <v-col cols="12" class="py-2">
        <v-divider
          v-show="i + 1 < value.extraFields.length"
          class="my-0"
        />
      </v-col>
    </v-row>

    <!-- Website for normal pages -->
    <v-card-text
      v-if="value.website && !isGiftRoute"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column"
      :style="textStyle"
    >
      <a
        :href="fixLink(value.website)"
        target="_blank"
        rel="noopener noreferrer"
        :style="textStyle"
      >
        <v-icon class="ml-auto" :color="value.pallete.textColor">
          mdi-web
        </v-icon>

        {{ value.website }}
      </a>
    </v-card-text>

    <!-- Gift title for gift and edit-gift pages -->
    <v-card-text
      v-if="value.website && isGiftRoute"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column"
      :style="textStyle"
    >
      <div :style="textStyle">
        <v-icon class="ml-auto" :color="value.pallete.textColor">
          mdi-heart
        </v-icon>

        {{ value.website }}
      </div>
    </v-card-text>

    <!-- About text -->
    <v-card-text
      v-if="value.aboutUs"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column about-us-wrapper"
    >
      <p
        dir="auto"
        class="about-us-text"
        :style="textStyle"
      >
        {{ value.aboutUs }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
const GIFT_ROUTES = [
  "qr.gift",
  "qr.name.editgift",
  "qr.name.id.editgift",
    "modelsList.memories.edit",
  "qr.create.memories"

];

export default {
  name: "ShowInfo",

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isIntersecting: false,
  }),

  computed: {
    isGiftRoute() {
      return GIFT_ROUTES.includes(this.$route.name);
    },

    textStyle() {
      return {
        color: this.value.pallete.textColor,
      };
    },

    cardStyle() {
      return {
        background: this.value.pallete.headColor,
        color: this.value.pallete.textColor,
      };
    },
  },

  watch: {
    isIntersecting(value) {
      this.$emit("intersecting", value);
    },
  },

  methods: {
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
    },

    extraIsLink(item) {
      return Boolean(item.link && item.link.length > 0);
    },

    fixLink(link) {
      if (!link) {
        return "";
      }

      return /^https?:\/\//i.test(link) ? link : `https://${link}`;
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.about-us-wrapper {
  padding-inline: 24px;
}

.about-us-text {
  width: 100%;
  margin: 0;
  white-space: pre-line;
  unicode-bidi: plaintext;
  text-align: start;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: normal;
  text-align: justify;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
</style>
